import React, { useCallback, useState } from 'react';
import styles from './index.modules.scss';
import { Input } from '@mantine/core';
import { Text } from '@shakkerai/pro-components';
import { Icon } from '@shakkerai/components';

export const SearchInput = (props) => {
  const { onSearch, onChange, className, radius = '51', ...rest } = props;
  const [value, setValue] = useState('');

  const onKeyDown = useCallback(
    (args) => {
      if (args.keyCode === 13) {
        // 13为enter
        onSearch(value);
      }
    },
    [value, onSearch],
  );

  return (
    <Input
      className={`${styles.searchInput} ${className}`}
      rightSectionPointerEvents="all"
      onKeyDown={onKeyDown}
      value={value}
      data-search-input
      radius={radius}
      onChange={(event) => {
        setValue(event.currentTarget.value);
        onChange && onChange(event);
      }}
      rightSection={
        value ? (
          <Text
            color="#5C636B"
            onClick={() => {
              setValue('');
              onSearch('');
            }}
            data-role="gen-history-trigger"
            className="mr-4"
            size={12}
          >
            Clear
          </Text>
        ) : (
          <Icon className="icon-border_search cursor-pointer" fontSize={14} color="var(--color-primary-grey)" />
        )
      }
      {...rest}
    />
  );
};
